import backofficeService from '../../../api/backoffice'
// let cacheCategory = null
export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    // if (cacheCategory) return cacheCategory
    return backofficeService.Api().get('category', {
      params
    })
      .then(response => {
        // cacheCategory = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },



  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`category/${id}`, {
      params
    })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('category', data)
      .then(response => {
        // cacheCategory = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`category/${id}`, data)
      .then(response => {
        // cacheCategory = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`category/${id}`, {
      params
    })
      .then(response => {
        // cacheCategory = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  merge(data) {
    return backofficeService.Api().post('category/merge', data)
      .then(response => {
        // cacheCategory = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  updateSortOrder(data) {
    return backofficeService.Api().post('category/sort-order', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}